<template>
  <Modal v-model="modalEmpresa">
    <Loading text="Loading" :loading="isLoading" />
    <div slot="header">Editar Detalhes da Loja</div>
    <Row :style="{'width': `${this.modalWidth}`,  'min-height':'200px'}">
     <Cell width="24">
          <fieldset class="form-edit-empresas">
            <legend>Gerenciar Empresa</legend>
            <div>
              <p>Nome fantasia:</p>
              <p class="form-edit-empresas-info">  {{loja.nome}} </p>
              <input :disabled="true" type="hidden" desabled v-model="loja.nome"  placeholder="Nome fantasia"/>
            </div>
            <div>
              <p>Razão social:</p>
              <p class="form-edit-empresas-info">  {{loja.nome}} </p>
              <input :disabled="true" type="hidden" v-model="loja.nome" placeholder="Razão social" />
            </div>
            <div>
              <p>CNPJ:</p>
              <p class="form-edit-empresas-info">  {{loja.cnpj || ' - '}} </p>
              <input :disabled="true" type="hidden" v-model="loja.cnpj" placeholder="CNPJ" />
            </div>
          </fieldset>
          <fieldset class="form-edit-empresas">
            <div>
              <p>Tipo de operação:</p>
              <div class="checkboxContainer-empresas">
                <Checkbox  v-model="loja.isRetail">
                      <label>  Varejo</label>
                </Checkbox>
                <Checkbox  v-model="loja.isResale">
                      <label>  Venda Direta</label>
                </Checkbox>
              </div>
            </div>
            <template v-if="loja.isResale">
              <TableEstruturas :refVendaDireta="valuesToEdit" @AbrirModalEstruturas="handleOpenEstruturasModal" />
            </template>
          </fieldset>
      </Cell>
    </Row>
    <div slot="footer" class="footer-nova-estrutura">
        <button v-if="loja.isResale" :disabled="isLoading"  class="h-btn h-btn-blue btn-nova-estrutura" @click="handleOpenModalNovaEstrutura">
          <i class="h-icon-plus" /> Nova estrutura de venda direta
        </button>
      <button :disabled="isLoading" class="h-btn" @click="handleCloseModal">Cancelar</button>
      <button :disabled="isLoading || !isSelectedOperacao" class="h-btn h-btn-green" color="green" @click="handleSaveInfos(false)">Salvar detalhes da Loja</button>
    </div>
  </Modal>
</template>
<script>
import { ScreenSize } from '../../mixins/ModalSize';
import { compare } from 'fast-json-patch';
import TableEstruturas from './tableEstruturas';
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapMutations, mapActions } = createNamespacedHelpers('empresas');
const { mapActions: mapActionsRevendedores } = createNamespacedHelpers('revendedores');
export default {
  name: 'Modalempresas',
  mixins: [ScreenSize],
  components: {
    TableEstruturas
  },
  data() {
    return {
      loja: {},
      isLoading: false
    };
  },
  mounted() {
  },
  computed: {
    ...mapState({
      modalEmpresa: state => state.modalEmpresa,
      valuesToEdit: state => state.valuesToEdit
    }),
    modalWidth() {
      return `${this.screen.widthSize < 400
        ? this.screen.widthSize
        : this.screen.widthSize - 200}px`;
    },
    isSelectedOperacao() {
      const { isResale, isRetail } = this.loja;
      return isResale || isRetail;
    }
  },
  methods: {
    ...mapMutations(['handleOpenModalEmpresas', 'handleOpenModalVd', 'setReferenceEmpresa', 'setValuesToEdit']),
    ...mapActions(['novaEstrutura', 'getEmpresas']),
    ...mapActionsRevendedores(['cleanValuesEdit']),
    async handleSaveInfos() {
      this.isLoading = true;
      const { _id } = this.loja;
      const diff = compare(this.valuesToEdit, this.loja);
      try {
        await R.Empresa.alterar(diff, _id);
        await this.getEmpresas();
        this.$Message.success('As informações da loja foram atualizadas');
      } catch (error) {
        console.log(error);
        this.$Message.error('Houve um erro ao salvar as alterações');
      } finally {
        this.isLoading = false;
        this.handleOpenModalEmpresas(false);
      }
    },
    handleOpenEstruturasModal() {
      this.novaEstrutura();
    },
    async handleOpenModalNovaEstrutura() {
      await this.handleSaveInfos(false);
      this.setReferenceEmpresa(this.loja._id);
      this.novaEstrutura();
      this.cleanValuesEdit();
      this.handleOpenModalEmpresas(false);
    },
    handleCloseModal() {
      this.handleOpenModalEmpresas(false);
      this.setValuesToEdit({});
    }
  },
  watch: {
    valuesToEdit() {
      const valuesLojas = JSON.stringify(this.valuesToEdit);
      this.loja = JSON.parse(valuesLojas);
    }
  }
};
</script>
<style>
.form-edit-empresas{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border: 1px solid #f3f6f8;
  background: #ffffff;
  padding: 8px;
  overflow: scroll;
  min-width: 100%;
}
.checkboxContainer-empresas{
  display: flex;
  gap: 8px;
  padding: 4px
}
.form-edit-empresas p{
  font-weight: bold;
}

.form-edit-empresas input{
  width: 300px;
}

.form-edit-empresas-info{
background: #fdfdfd;
box-shadow: 1px 1px 2px #0000002d;
padding: 4px;
min-width: 250px;
margin: 4px;
border-radius: 4px;
height: 30px;
display: flex;
align-items: center;
}
fieldset + fieldset {
margin-top: 8px ;
}

.footer-nova-estrutura{
display: flex;
flex-wrap: wrap;
justify-content: flex-end;
gap: 4px;
}
.btn-nova-estrutura{
margin-right: auto;
}
@media (max-width: 600px){
 .footer-nova-estrutura{
  flex-direction: column;
 }
 .btn-nova-estrutura{
  margin: 8px auto;
}
}
</style>
